import {LISTING, TRANSACTION, APPROVAL_LIST, ADD_MONEY, APPROVAL_LIST_DATA, VIEW_REQUEST, REQUEST_ACTION, WALLET_FINANCE_REQUEST, REQUEST_TRANSACTION_LIST,WALLET_REQUEST_LIST,FETCH_DEALER_DATA,LISTING_DEALER,LISTING_DEALER_APPROVAL} from "./type";

const initalState = {
    listing: [],
    transaction:[],
    approvalList:[],
    addedMoney:[],
    approvlListData: [],
    requestById:[],
    requestedAction:[],
    walletfinancerequest:[],
    requesttransactionlisting:[],
    walletrequestlist:[],
    dealerData: [],
    dealerPaymentRequests: [],
    dealerPaymentRequestApproval: [],
};

const Wallet = (state = initalState, action) => {
    const { type, payload } = action;
    switch (type) {
        case LISTING:
            return {
                ...state,
                listing: payload
            };
        case TRANSACTION:
            return {
                ...state,
                transaction: payload.response.data,
            };
        case APPROVAL_LIST:
            return {
                ...state,
                approvalList: payload?.response?.data,
            };
        case ADD_MONEY:
            return {
                ...state,
                addedMoney: payload,
            };
        case APPROVAL_LIST_DATA:
            return {
                ...state,
                approvlListData: payload?.response?.data,
            };
        case VIEW_REQUEST:
            return {
                ...state,
                requestById: payload.response.data,
            };
        case REQUEST_ACTION:
            return {
                ...state,
                requestedAction: payload,
            };
        case WALLET_FINANCE_REQUEST:
            return {
                ...state,
                walletfinancerequest: payload,
            };
        case REQUEST_TRANSACTION_LIST:
            return {
                ...state,
                requesttransactionlisting: payload,
            };
        case WALLET_REQUEST_LIST:
            return {
                ...state,
                walletrequestlist: payload,
            };
        case FETCH_DEALER_DATA:
            return {
                ...state,
                dealerData: payload,
            };
        case LISTING_DEALER:
            return {
                ...state,
                dealerPaymentRequests: payload,
            };
        case LISTING_DEALER_APPROVAL:
            return {
                ...state,
                dealerPaymentRequestApproval: payload,
            };            
        default:
            return {
                ...state,
            };
    }
};

export default Wallet;
